import { BankEligibilityBeneficialOwner } from '@/domains/Business/types'
import { getFullName } from '@/lib/typography'
import { Typography } from '@/shared/ui'

type Props = {
  owner: BankEligibilityBeneficialOwner
}

export const OwnerNameCell = ({ owner }: Props) => {
  return (
    <div className="flex flex-col justify-center">
      <Typography bold>{getFullName(owner)}</Typography>
      <Typography variant="body-small" className="text-neutral-gray-600">
        {owner.email}
      </Typography>
    </div>
  )
}
